import customAxios from "./axiosConfig";

const BalanceSheetService = {
    list: function (params) {
        var api_url = window.Urls['balance_sheet_item_list']();
        return customAxios.get(api_url, {params: params});
    },
    loadPage: function (page_url) {
        return customAxios.get(page_url);
    },
    retrieve(pk) {
        var api_url = window.Urls['balance_sheet_item_detail'](pk);
        return customAxios.get(api_url);
    },
    create: function(data) {
        var api_url = window.Urls['balance_sheet_item_list']();
        return customAxios.post(api_url, data);
    },
    update: function(pk, data) {
        var api_url = window.Urls['balance_sheet_item_detail'](pk);
        return customAxios.put(api_url, data);
    },
    updateMany: function(data) {
        var api_url = window.Urls['balance_sheet_item_update_many']();
        return customAxios.put(api_url, data);
    },
    delete: function(pk) {
        var api_url = window.Urls['balance_sheet_item_detail'](pk);
        return customAxios.delete(api_url);
    },
    prepareDataForUpdate: function(data) {
        if (data["amount"]) {
            let totalAmount = parseFloat(data["amount"]).toFixed(2);
            data["amount"] = totalAmount.toString();
        } else {
            data["amount"] = 0;
        }
        
        data["writeoffyear_set"] = [];
        Object.keys(data).forEach(key => {
            let year = parseInt(key);
            if (year) {
                let yearAmount = 0;
                if (data[year.toString()]) {
                    if (data[year.toString()]) {
                        yearAmount = parseFloat(data[year.toString()]);

                        data["writeoffyear_set"].push({
                            amount: yearAmount.toString(),
                            year: year
                        });
                    }
                }
            }
        });
        
        let date = Date.parse(data.date);
        let month = date.getMonth() + 1; // getMonth would return a value between 0 and 11
        let strDate = date.getFullYear() + "-" + month + "-" + date.getDate();
        
        let newData = {
            id: data["id"],
            date: strDate,
            amount: data["amount"],
            description: data["description"],
            cost_type: data["cost_type"],
            company_profile: data["company_profile"],
            writeoffyear_set: data["writeoffyear_set"],
            comment: data["comment"]
        }
        
        return newData;
    }
};

export default BalanceSheetService;